import VerifiedIcon from "@mui/icons-material/Verified";
import UnsubscribeIcon from "@mui/icons-material/UnsubscribeOutlined";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnreadOutlined";
import { UIStack, UITooltip } from "../index";
import { EmailDeliveryFailure } from "../../api/types";
import { emailDeliveryFailureTooltip, isEmailSuppressed } from "../../utils/emailDelivery";

export interface UIEmailWithVerificationProps {
  email: string;
  isValidated?: boolean;
  emailDeliveryFailure?: EmailDeliveryFailure | null;
}

const UIEmailWithVerification = ({ email, isValidated = false, emailDeliveryFailure }: UIEmailWithVerificationProps) => {
  return (
    <UIStack direction="row" alignItems="center" gap={1}>
      {email}
      {emailDeliveryFailure ? (
        <UITooltip title={emailDeliveryFailureTooltip(emailDeliveryFailure)}>
          {isEmailSuppressed(emailDeliveryFailure) ? (
            <UnsubscribeIcon color="error" fontSize="small" data-testid="email-suppressed-icon" />
          ) : (
            <MarkEmailUnreadIcon color="warning" fontSize="small" data-testid="email-delivery-failed-icon" />
          )}
        </UITooltip>
      ) : (
        isValidated && (
          <UITooltip title="Email Verified">
            <VerifiedIcon color="success" fontSize="small" />
          </UITooltip>
        )
      )}
    </UIStack>
  );
};

export default UIEmailWithVerification;
